// import components
import type { BoxProps } from '@mui/material';
import { styled, Box } from '@mui/material';

// import types
import type { StyledActivityPlanningBoxProps } from './ActivityPlanning.types';

export const StyledActivityPlanningBox = styled(Box)<
  BoxProps & StyledActivityPlanningBoxProps
>(({ overflowX, overflowY }) => ({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  overflowX,
  overflowY
}));
